import { IBusinessPriorityApi } from '../api/types'
import { IBusinessPriorityForm } from '../model/types'

export type TBusinessPriorityApiPayload = Pick<
  IBusinessPriorityApi,
  'Name' | 'Description' | 'Status' | 'Markets' | 'Offerings' | 'FYear'
> &
  Partial<Pick<IBusinessPriorityApi, 'UID'>>

export const mapBusinessPriorityToApi = (
  form: IBusinessPriorityForm,
  fYear: number
): TBusinessPriorityApiPayload => ({
  Name: form.name,
  Description: form.description,
  Status: form.status,
  Markets: form.markets.join(','),
  Offerings: form.programOfferings.join(','),
  FYear: fYear,
  ...(form.uid ? { UID: form.uid } : {}),
})
